import {
  Button,
  Col,
  Empty,
  Modal,
  Row,
  Space,
  Spin,
  Table,
  message,
} from "antd";
import { useEffect, useState } from "react";
import { columnContentWeb } from "../../common/columns";
import {
  deleteContentWeb,
  getAllContentWeb,
} from "../../../../api/service/api-content";
import dayjs from "dayjs";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import FromDetail from "../content/Detail";

const ContentWeb = () => {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsvisible] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!isVisible) getData();
  }, [isVisible]);

  function getData() {
    setLoading(true);
    getAllContentWeb()
      .then((res) => {
        setDataSource(mapDataSource(res?.data));
      })
      .finally(() => setLoading(false));
  }

  const mapDataSource = (values) => {
    return values?.map((item) => ({
      ...item,
      key: item.id,
      createDate: dayjs(item.createdAt).format("DD-MM-YYYY"),
      menu: (
        <>
          <Row gutter={12} justify={"end"} align={"middle"}>
            <Col>
              <EditOutlined
                onClick={() => {
                  setData(item);
                  setIsvisible(true);
                }}
              />
            </Col>
            <Col>
              <DeleteOutlined onClick={() => confirmDelete(item.id)} />
            </Col>
          </Row>
        </>
      ),
    }));
  };

  function confirmDelete(id) {
    Modal.confirm({
      title: "Xác nhận",
      content: "Bạn có chắc là muốn xóa thông tin dịch vụ này không?",
      okText: <div style={{ color: "white" }}>Xóa</div>,
      okButtonProps: {
        className: "bg-admin-btn-primary",
      },
      onOk: () => {
        deleteContentWeb(id).then((res) => {
          message.success("Xóa dịch vụ thành công");
          getData();
        });
      },
    });
  }

  const locale = {
    emptyText: (
      <Space direction="vertical" align="center" style={{ marginTop: "20px" }}>
        <Empty description={"Chưa có dữ liệu"} />
      </Space>
    ),
  };

  return (
    <>
      <div style={{ padding: "10px" }}>
        <Button type="dashed" onClick={() => setIsvisible(true)}>
          Thêm mới thông tin dịch vụ
        </Button>
      </div>
      <Spin tip="Xin vui lòng chờ..." spinning={loading}>
        <Table
          columns={columnContentWeb}
          dataSource={dataSource}
          locale={locale}
        />
      </Spin>
      <FromDetail
        isVisible={isVisible}
        onCancel={() =>{
          setIsvisible(false)
          setData(undefined)
        }}
        data={data}
      />
    </>
  );
};
export default ContentWeb;
